import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from '../../../../mtska-frontend-app-component';
import { useDataProvider } from '../../../../mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';
const wizardName = 'Check production';
const wizardObject = 'Pool Car';
const wizardAction = 'getRulesetByCar';

const ProductionCheck = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);


    // DATA PROVIDER
    const {
        item,
        errorMessage,
        errors,
        saving,
        doAction,
    } = useDataProvider(dataProviderName, params.multipart);

    const modelName = existingModules.modelName

    const detailConfig = {
        "tabs": [
            {
                "name": "association",
                "fieldsets": [
                    {
                        "name": "association",
                        "fields": {
                            "production_check": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "carId": {
                                "type": "text",
                                "className": "col-12",
                                "readonly":true
                            },
                            "all_good_message": {
                                "type": "sectionmessageblock",
                                "title": "production_check_message_title",
                                "paragraph": "production_check_message_paragraph",
                                "icon": "faArrowTrendUp",
                                "className": "col-12 success",
                            }
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data }).then(
            (data) => close()
        ).catch(() => console.error('catch handleSave'));
    }

    return <>
        <DetailComponent
            values={{ "carId": item?.data?._id }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.productioncheck']}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Verify the commercial production of {{carIdentifier}}', { carIdentifier: (item.data.plate ? item.data.plate : item.data.setup?.make + " " + item.data.setup?.model) })}
                />
            }
            {...params}
        />
    </>
}

export default ProductionCheck;


